'use client';

import { useTheme } from 'next-themes';
import { Toaster } from 'react-hot-toast';

export function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  const isLight = resolvedTheme === 'light';

  return (
    <Toaster
      position="top-center"
      toastOptions={{
        style: {
          background: isLight ? 'rgba(255, 255, 255, 0.92)' : 'rgba(20, 20, 25, 0.92)',
          backdropFilter: 'blur(20px)',
          color: isLight ? '#060606' : '#ffffff',
          border: isLight
            ? '1px solid rgba(0, 0, 0, 0.08)'
            : '1px solid rgba(255, 255, 255, 0.08)',
          borderRadius: '12px',
          fontSize: '0.875rem',
          padding: '0.625rem 0.875rem',
        },
      }}
    />
  );
}
